import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import Button from '@material-ui/core/Button';
import InputBase from '@material-ui/core/InputBase';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import MailIcon from '@material-ui/icons/MailOutline';
import PhoneIcon from '@material-ui/icons/Phone';
import { withStyles } from '@material-ui/core/styles';
import links from 'utils/links';
import swal from 'sweetalert';
import configElasticEmail from 'utils/config';

const styles = theme => ({
  innerContainer: {
    maxWidth: 375,
  },
  darkBg: {
    backgroundColor: theme.palette.primary.dark,
    color: 'white',
  },
  mainBg: {
    backgroundColor: theme.palette.primary.main,
  },
  emailBox: {
    color: theme.palette.primary.light,
    borderColor: theme.palette.primary.light,
  },
  subscribe: {
    [theme.breakpoints.up('md')]: {
      marginTop: -90,
    },
  },
});

const Title = ({ children }) => (
  <Typography
    className="uppercase"
    color="primary"
    gutterBottom
    variant="button"
  >
    {children}
  </Typography>
);

const ItemText = ({ children, className }) => (
  <Typography
    className={classNames(className, 'inline', 'text-light')}
    variant="caption"
  >
    {children}
  </Typography>
);

const ListItemLink = props => (
  <ListItem className="p-0" button component={Link} {...props} />
);

const ListItemTextLight = ({ children }) => (
  <ListItemText
    classes={{ primary: 'text-light' }}
    primary={<ItemText>{children}</ItemText>}
  />
);

const GetInTouch = ({ className }) => (
  <div className={className}>
    <Title>Get in Touch</Title>
    <address className="flex sm-flex-col">
      <div className="basis-50 sm-my-1">
        <MailIcon
          className="align-middle mr-2"
          color="primary"
          fontSize="small"
        />
        <ItemText>
          <a href="mailto:hello@talkingstreet.in">hello@talkingstreet.in</a>
        </ItemText>
      </div>
      <div className="basis-50">
        <PhoneIcon
          className="align-middle mr-2"
          color="primary"
          fontSize="small"
        />
        <ItemText>
          <a href="tel:+919380666054">93806 66054</a>
        </ItemText>
      </div>
    </address>
  </div>
);

class Subscribe extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      submitting: false,
      error: false,
      openNotification: false,
    };
  }
  onHandleChange = event => {
    event.preventDefault();
    this.setState({
      email: event.target.value,
    });
    // console.log(event.target.value);
  };

  onSubmit = event => {
    event.preventDefault();
    const apikey = configElasticEmail.elasticApiKey;
    const subject = 'Site Subcriber';
    const reciepent = 'maheima@talkingstreet.in ';
    this.setState({ submitting: true });
    fetch(
      `https://api.elasticemail.com/v2/email/send?apikey=${apikey}&subject=${subject}&from=${
        this.state.email
      }&to=${reciepent}&bodyText=New Subcriber`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(this.state.email),
      }
    )
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          this.setState({
            email: '',
            error: false,
            submitting: false,
            openNotification: true,
          });
          swal({
            text: 'You have successfully subcribed!',
            position: 'center center',
          });
        } else {
          this.setState({
            error: true,
            submitting: false,
          });
          swal({
            text: 'Oop! Error in submitting. Please try again',
            position: 'center center',
          });
        }
      });
    // console.log(this.state.error);
  };

  render() {
    const { className, classes } = this.props;
    return (
      <form
        className={className}
        name="subscribe"
        method="POST"
        onSubmit={event => this.onSubmit(event)}
      >
        <div className="flex mb-1">
          <InputBase
            className={classNames(
              'border border-light rounded flex-grow',
              classes.emailBox
            )}
            classes={{ input: 'px-3' }}
            autoComplete="email"
            name="email"
            placeholder="Email address"
            type="email"
            required
            onChange={e => this.onHandleChange(e)}
            value={this.state.email}
          />
          <Button
            className="-ml-1 uppercase"
            color="primary"
            type="submit"
            variant="contained"
          >
            Subscribe
          </Button>
        </div>
        <ItemText className="ml-4">
          We would love to send you our latest newsletter!
        </ItemText>
      </form>
    );
  }
}

const tempTSlistItems = [
  {
    name: 'Eateries',
    link: links.eateryLanding('Bangalore'),
  },
  {
    name: 'Culinary Experiences',
    link: links.experiences('Bangalore'),
  },
  {
    name: 'About Us',
    link: links.staticLink('about-us'),
  },
  {
    name: 'Team',
    link: links.staticLink('team'),
  },
  {
    name: 'Media Links',
    // link: links.mediaLinks(),
    link: `https://talkingstreet.in/home/mediaLinks`,
  },
  {
    name: 'Work with Us',
    link: links.staticLink('team'),
  },
];

const TalkingStreet = ({ className }) => (
  <div className={className}>
    <Title>Talking Street</Title>
    <List component="nav" dense>
      {/* {Object.entries(tsListItems).map(([href, child]) => (
        <ListItemLink key={href} to={href}>
          <ListItemTextLight>{child}</ListItemTextLight>
        </ListItemLink>
      ))} */}

      {tempTSlistItems.map((item, index) => {
        return (
          <React.Fragment key={item.name + 'me'}>
            {item.name === 'Media Links' ? (
              <a
                href="https://talkingstreet.in/home/mediaLinks"
                target="_blank"
                rel="noopener noreferrer"
              >
                <ListItemTextLight>{item.name}</ListItemTextLight>
              </a>
            ) : (
              <ListItemLink key={item.name} component={Link} to={item.link}>
                <ListItemTextLight>{item.name}</ListItemTextLight>
              </ListItemLink>
            )}
          </React.Fragment>
        );
      })}
    </List>
  </div>
);

// const contributorListItems = {
//   '/contributor/approach': 'Approach',
//   '/contributor/community-policies': 'Community Policies',
//   '/contributor/how-to': 'How to become a contributor',
//   '/': 'Your city contributors', // TODO: Dynamically link current city
//   '/contributor/faq': 'FAQs',
// };

const tempContributorListItems = [
  {
    name: 'Community Policies',
    link: links.staticLink('community'),
  },
  {
    name: 'How to become a contributor',
    link: links.staticLink('community'),
  },
  {
    name: "Your city's contributors",
    link: links.staticLink('community'),
  },
  {
    name: 'FAQs',
    link: links.staticLink('community'),
  },
];

const Contributor = ({ className }) => (
  <div className={className}>
    <Title>Our Contributor Community</Title>
    <List component="nav" dense>
      {/* {Object.entries(contributorListItems).map(([href, child]) => (
        <ListItemLink key={href} to={href}>
          <ListItemTextLight>{child}</ListItemTextLight>
        </ListItemLink>
      ))} */}

      {tempContributorListItems.map((item2, index) => {
        return (
          <ListItemLink key={item2.name} component={Link} to={item2.link}>
            <ListItemTextLight>{item2.name}</ListItemTextLight>
          </ListItemLink>
        );
      })}
    </List>
  </div>
);

const Ahara = ({ className }) => (
  <div className={className}>
    <Typography color="primary" gutterBottom variant="button">
      ahar&#x0101;
    </Typography>
    <List component="nav" dense>
      <ListItemLink to="/experiences/Bangalore">
        {/* <ListItemTextLight>Explore service partners</ListItemTextLight> */}
        <ListItemTextLight>Explore Culinary Experiences</ListItemTextLight>
      </ListItemLink>
    </List>
  </div>
);

const LinkImg = ({ alt, href, src }) => (
  <a className="m-2" href={href} target="_blank" rel="noopener noreferrer">
    <img alt={alt} src={src} />
  </a>
);

const ConnectWithUs = ({ className }) => (
  <div className={className}>
    <Title>Connect with Us</Title>
    <div className="flex">
      <LinkImg
        href="https://twitter.com/streetsthattalk"
        alt="Twitter"
        src="/img/twitter.svg"
      />
      <LinkImg
        href="https://www.instagram.com/talkingstreet/"
        alt="Instagram"
        src="/img/instagram.svg"
      />
      <LinkImg
        href="https://www.facebook.com/streetsthattalk"
        alt="Facebook"
        src="/img/facebook.svg"
      />
    </div>
  </div>
);

const Legal = ({ classes }) => (
  <div
    className={classNames('flex flex-wrap px-6 py-2 sm-py-4', classes.mainBg)}
  >
    <div className="sm-order-3 flex-grow" />
    <Link
      className={classNames('basis-100', 'sm-basis-auto sm-order-4')}
      to="/privacy-policy"
    >
      <Typography
        className="text-light sm-mb-0"
        align="center"
        gutterBottom
        variant="body2"
      >
        Privacy policy
      </Typography>
    </Link>
    <Typography
      className={classNames('text-light basis-100', 'sm-basis-auto sm-order-1')}
      align="center"
      variant="body2"
    >
      Copyright &copy; 2019 www.talkingstreet.in.
    </Typography>
    <Typography
      className={classNames(
        'text-light basis-100 mx-2',
        'sm-basis-auto sm-order-2'
      )}
      align="center"
      variant="body2"
    >
      All Rights Reserved.
    </Typography>
  </div>
);

const Footer = ({ classes }) => {
  return (
    <footer>
      <div
        className={classNames(
          'flex justify-center px-4 pt-4',
          'sm-px-6 sm-pt-6 sm-pb-3',
          classes.darkBg
        )}
      >
        <div
          className={classNames(
            'flex flex-wrap max-w-sm max-w-md',
            classes.innerContainer
          )}
        >
          <GetInTouch
            className={classNames(
              'mb-4 basis-100 order-1',
              'sm-basis-33 sm-order-4',
              'md-basis-20'
            )}
          />
          <div className="md-order-7 md-basis-60" />
          <Subscribe
            classes={classes}
            className={classNames(
              'mb-4 basis-100 order-2',
              'sm-order-7',
              'md-basis-40',
              classes.subscribe
            )}
          />
          <TalkingStreet
            className={classNames(
              'mb-4 basis-50 order-3',
              'sm-basis-33 sm-order-1',
              'md-basis-20'
            )}
          />
          <Contributor
            className={classNames(
              'mb-4 basis-50 order-4',
              'sm-basis-33 sm-order-2',
              'md-basis-20'
            )}
          />
          <Ahara
            className={classNames(
              'mb-3 basis-50 order-5',
              'sm-basis-33 sm-order-3',
              'md-basis-20'
            )}
          />
          <ConnectWithUs
            className={classNames(
              'mb-1 basis-50 order-6',
              'sm-basis-33 sm-order-5',
              'md-basis-20'
            )}
          />
        </div>
      </div>
      <Legal classes={classes} />
    </footer>
  );
};

export default withStyles(styles)(Footer);
